import { observer } from 'mobx-react';
import React, { useEffect } from 'react';

import useStores from 'hooks/use-stores';
import { FooterBar } from 'main/components/bar/FooterBar';
import LoginNotification from 'pages/components/LoginNotification';
import isEmpty from 'utils/is-empty';

import Content from './components/Content';
import HistoryOfChangesProvider from './components/HistoryOfChangesProvider';
import PrivateArea from './components/Private';
import Related from './components/Related';
import RelatedBox from './components/RelatedBox';
import Score from './components/Score';
import useStyles from './styles';
import useIsMobile from 'pages/landing/v2/Main/hooks/use-is-mobile';

interface Props {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    references: any;
}

const Item: React.FC<Props> = ({ data, references }) => {
    const { classes } = useStyles();
    const { naslStore } = useStores();
    const isMobile = useIsMobile();

    useEffect(() => {
        if (isEmpty(naslStore.naslTypes)) {
            naslStore.loadTypes();
        }
    }, [naslStore]);

    if (!data) {
        return null;
    }

    const aiScore = data.enchantments?.score;
    const { cvss2, cvss3, epss, id, type, privateArea } = data;

    return (
        <HistoryOfChangesProvider id={id}>
            <div className={classes.item}>
                <div className={classes.contentWrapper}>
                    <div className={classes.content}>
                        <Content data={data} />
                    </div>

                    {privateArea ? (
                        <div className={classes.privateArea}>
                            <PrivateArea bulletinType={type} privateArea={privateArea} />
                        </div>
                    ) : null}

                    {isEmpty(references) ? null : (
                        <div className={classes.related}>
                            <Related references={references} />
                        </div>
                    )}

                    <FooterBar />
                </div>
                {!isMobile && (
                    <div className={classes.score}>
                        <Score aiScore={aiScore} cvss2={cvss2} cvss3={cvss3} epss={epss} id={id} />
                        {isEmpty(references) ? null : <RelatedBox cveId={id} references={references} />}
                    </div>
                )}
            </div>
            <LoginNotification />
        </HistoryOfChangesProvider>
    );
};

export default observer(Item);
